import React, { useEffect, useState } from "react";
import '../css/customModalMovementsInfo.css'
import '../css/partnersPage.css';
import Modal from 'react-bootstrap/Modal';
import CustomButton from "./CustomButton";
import { IoSearch } from "react-icons/io5";
import Form from 'react-bootstrap/Form';
import { IoMdClose } from "react-icons/io";
import { RiMapPinLine } from "react-icons/ri";
import { FaArrowRightLong, FaArrowLeftLong } from "react-icons/fa6";
import portugalLocationsData  from "../data/portugal.json";
import { useMobileMediaQuery, useTabletMediaQuery } from '../utils';

const CustomFilterModal = (props) => {
    const {
        title = '',
        seacrhForNamePartner = '',
        setSeacrhForNamePartner = '',
        nomesParceirosList,
        partnersListMock,
        seacrhForPlacePartner = '',
        setSeacrhForPlacePartner = '',
        locationDistance,
        marks,
        min,
        max,
        setLocationDistance,
        theme,
        countAccommodationTravel,
        countSustainability,
        isSustainability,
        isAccommodationTravel,
        countSport,
        isSport,
        countBeautyStore,
        isBeautyStore,
        countChildrenEducation,
        isChildrenEducation,
        countCultureLeisure,
        isCultureLeisure,
        countTech,
        isTech,
        countModaHome,
        isModaHome,
        countAnimals,
        isAnimals,
        countCarsTransp,
        isCarsTransp,
        countRestaurantStore,
        isRestaurantStore,
        countOther,
        isOther,
        countStoreOnline,
        isStoreOnline,
        countStorePhysical,
        isStorePhysical,
        countNew,
        isNew,
        selectedItem,
        setSelectedItem,
        selectedArrayItems,
        filters,
        filteredPartnersPlace = [],
        setFilteredPartnersPlace = [],
        selectedSeacrhForPlacePartner,
        setSelectedSeacrhForPlacePartner,
        setPageNumber,
    } = props;

    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const [openSelectCityModal, setOpenSelectCityModal] = useState(false);
    const [openSelectSecCityModal, setOpenSelectSecCityModal] = useState(false);
    const [openDropDownSeacrhForPlacePartner, setOpenDropDownSeacrhForPlacePartner] = useState(false);
    const [isFocusedInputSeacrhForPlace, setIsFocusedInputSeacrhForPlace] =  useState(false);
    
    const handleClose = () => setOpenSelectCityModal(false);
    const handleShow = () => setOpenSelectCityModal(true);

    const handleCloseThird = () => setOpenSelectSecCityModal(false);
    const handleShowThird = (item) => {
        setOpenSelectSecCityModal(true);
        setSelectedItem(item);
    }

    const handleMainClose = () => {
        handleClose();
        props.onHide();
        handleCloseThird();
    };

    const handleSeacrhForPlacePartner = (item) => {
        setSeacrhForPlacePartner(item)
        setSelectedSeacrhForPlacePartner(true);
    }

    const handleFocusInputSeacrhForPlace = () => {
        setIsFocusedInputSeacrhForPlace(true);
        setOpenDropDownSeacrhForPlacePartner(true)
    };
    
    const handleBlurInputSeacrhForPlace = () => {
        setIsFocusedInputSeacrhForPlace(false);
        const delay = setTimeout(() => {
            setOpenDropDownSeacrhForPlacePartner(false) 
            setPageNumber(1);
            }, 500); 
    
            return () => clearTimeout(delay); 
    };
    

    /* const handleInputSeacrhForPlaceChange = (event) => {
        const newValue = event.target.value;
        setSeacrhForPlacePartner(newValue);
        if (newValue.length === 0) {
            setSelectedSeacrhForPlacePartner(false);
        }
    }; */

    const handleInputSeacrhForPlaceChange = (event) => {
        const newValue = event.target.value.replace(/\d/g, '');
        setSeacrhForPlacePartner(newValue);
    
        if (newValue.length > 0) {
            setSelectedSeacrhForPlacePartner(false);
            const uniqueNames = new Map();
    
            portugalLocationsData.portugalLocations?.forEach(partner => {
                // Add the top-level district name to the map if it matches
                if (partner.name.toLowerCase().includes(newValue.toLowerCase())) {
                    uniqueNames.set(partner.name, 'district');
                }
    
                // Add "conselhos" names to the map only if they are not already in it
                partner.conselhos?.forEach(conselho => {
                    if (
                        conselho.name.toLowerCase().includes(newValue.toLowerCase()) &&
                        !uniqueNames.has(conselho.name)
                    ) {
                        uniqueNames.set(conselho.name, 'conselho');
                    }
                });
            });
    
            // Get only the keys (names) from the map
            const filteredNames = Array.from(uniqueNames.keys());
            setFilteredPartnersPlace(filteredNames);
        } else if (newValue.length === 0) {
            setSelectedSeacrhForPlacePartner(false);
        } else {
            setFilteredPartnersPlace([]);
        }
    };
    

    const handleSelectOneOFTheLastThree = (item) => {
        alert(item.name)
    }
    
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.target.blur();
            setSelectedSeacrhForPlacePartner(true);
        }
    };

    const highlightMatchedText = (text, query) => {
        if (!query) return text;
    
        const regex = new RegExp(`(${query})`, 'gi');
        const parts = text.split(regex);
    
        return parts.map((part, index) =>
            regex.test(part) ? (
                <span key={index} className="highlightPartnersPage">{part}</span>
            ) : (
                part
            )
        );
    };

    return (
        <Modal
            {...props}
            size="lg-down"
            fullscreen
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modalMainContainerPartnersPageMobile"
        >
            <div className='mainOptionsColumnViewContainerModalPartnersPageMobile'>
                <div className='txtFirstOptionsTitleViewRowPartnersPageMobile'>
                    <div className='txtFirstOptionsTitlePartnersPage'>Filtrar</div>
                    <button className='btnFirstOptionsTitlePartnersPage' onClick={props.onHide}><IoMdClose className="closeIconPartnersPage"/></button>
                </div>
                <div className='optionsDeviderLinePartnersPage'></div>
                <div className='txtFirstOptionsTitleViewPartnersPage'>
                    <div style={{ marginBottom: '24px'}}>
                        <div className='txtFirstOptionsTitlePartnersPage'>Por localização</div>
                    </div>
                    <button className='btnSecModalWothLocationPartnersPageMobile' onClick={handleShow}>
                        <div  className='txtLocBtnPartnersPage'><RiMapPinLine className='locIconPartnersPage' /> Localização</div>
                        <FaArrowRightLong className='navIconPartnersPage'/>
                    </button>
                    <Modal 
                        show={openSelectCityModal} 
                        size="lg-down"
                        fullscreen
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        className="modalMainContainerPartnersPageMobile"
                        >
                            <div className='mainOptionsColumnViewContainerModalPartnersPageMobile'>
                                <div className='txtFirstOptionsTitleViewRowPartnersPageMobile'>
                                    <div className='titleSecondModalViewRowPartnersPageMobile'>
                                        <button className="btnFirstOptionsTitlePartnersPage" onClick={handleClose}><FaArrowLeftLong className='navIconPartnersPage'/></button>
                                        <div className='txtFirstOptionsTitlePartnersPage'>Localização</div>
                                    </div>
                                    <button className='btnFirstOptionsTitlePartnersPage' onClick={handleMainClose}><IoMdClose className="navIconPartnersPage"/></button>
                                </div>
                                <div className='optionsDeviderLinePartnersPage'></div> 
                               
                                <div className='textWrapperModalPartnersPage'>
                                    { (isFocusedInputSeacrhForPlace || seacrhForPlacePartner.length > 0) &&
                                        <label className='label-focusPartnersPage'>Localidade</label>
                                    }
                                    <input 
                                        className={ isTablet ? 'inputTextPartnersPageModal' : 'inputTextPartnersPageModalMobile'}
                                        type="text" 
                                        placeholder={ !isFocusedInputSeacrhForPlace ? 'Localidade' : undefined}
                                        value={seacrhForPlacePartner}
                                        onChange={handleInputSeacrhForPlaceChange}
                                        onFocus={handleFocusInputSeacrhForPlace}
                                        onBlur={handleBlurInputSeacrhForPlace}
                                        onKeyDown={handleKeyDown}
                                        autoComplete='off'
                                        spellCheck="false"
                                        inputMode='text'
                                        //maxLength={15}
                                    />
                                    <div className='findIconViewPartnersPageMobile' onClick={props.handleClickShowInfo}><IoSearch className='findIconPartnersPage' /></div>
                                </div>
                                { ((seacrhForPlacePartner.length > 0 && !selectedSeacrhForPlacePartner) && openDropDownSeacrhForPlacePartner )  && (
                                <>
                                    <div className={filteredPartnersPlace.length > 3 ? 'textWrapperViewCollumnPartnersPage' : 'textWrapperSmallViewCollumnPartnersPage'} style={{marginTop: '-16px'}}>
                                        <div className={ filteredPartnersPlace.length > 1 ? 'textWrapperCollumnPartnersPage' : 'textWrapperNoScrollCollumnPartnersPage'}>
                                            {filteredPartnersPlace?.map((item, index)=>(
                                                <div key={index} className="searchPosCodListViewPartnersPage">
                                                    <button  className='txtSelectPlaceBtnPartnersPage' onClick={() => handleSeacrhForPlacePartner(item)}>
                                                        {highlightMatchedText(item, seacrhForPlacePartner)}
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </>
                                )}
                                {/* <div className='optionsDeviderLinePartnersPage'></div>
                                <div className='txtFirstOptionsTitleScrollViewPartnersPage'>
                                    <div style={{ marginBottom: '24px'}}>
                                        <div className='txtFirstOptionsTitlePartnersPage'>Visto Recentemente</div>
                                    </div>
                                    {portugalLocationsData.portugalLocations.map((item, index)=>(
                                    <div key={index} style={{ marginTop: '16px' }}>
                                        <button className='btnThreeLastSelectedPartnersPageMobile' onClick={() => handleSelectOneOFTheLastThree(item)}>
                                            <div  className='txtThreeLastSelectedPartnersPageMobile'>{item.name}</div>
                                        </button>
                                    </div>
                                    ))}
                                </div>
                                 */}
                                <div className='optionsDeviderLinePartnersPage'></div>
                                <div className='txtFirstOptionsTitleViewPartnersPage'>
                                    <div style={{ marginBottom: '24px'}}>
                                        <div className='txtFirstOptionsTitlePartnersPage'>Distritos</div>
                                    </div>
                                    {portugalLocationsData.portugalLocations.map((item, index)=>(
                                    <div key={index} style={{ marginBottom: '32px' }}>
                                        <button className='btnSecModalWothLocationPartnersPageMobile' onClick={() => handleShowThird(item)}>
                                            <div  className='txtDistBtnPartnersPage'>{item.name}</div>
                                            <FaArrowRightLong className='navIconPartnersPage'/>
                                        </button>
                                    </div>
                                    ))}
                                    <div className='optionsDeviderLinePartnersPage'></div>
                                    <div className='fotterMobalBtnViewPartnersPage' style={{ paddingTop: '32px', marginBottom: '64px'}}>
                                        <CustomButton 
                                            text={'Limpar tudo'} 
                                            textColor={'#00214D'}
                                            onPress={props.handleClearFilter} 
                                            enabled={props.handleEnabledBtnFilter()}
                                            color={'#fff'}
                                            borderColor={'#00214D'}
                                            isSmall
                                        />
                                        <CustomButton 
                                            text={'Aplicar filtros'} 
                                            color={'#15D4B6'}
                                            textColor={'#00214D'}
                                            onPress={handleMainClose}
                                            enabled={props.handleEnabledBtnFilter()}
                                            isSmall
                                        />
                                    </div>
                                    <Modal 
                                        show={openSelectSecCityModal} 
                                        size="lg-down"
                                        fullscreen
                                        aria-labelledby="contained-modal-title-vcenter"
                                        centered
                                        className="modalMainContainerPartnersPageMobile"
                                        >
                                            <div className='mainOptionsColumnViewContainerModalPartnersPageMobile'>
                                                <div className='txtFirstOptionsTitleViewRowPartnersPageMobile'>
                                                    <div className='titleSecondModalViewRowPartnersPageMobile'>
                                                        <button className="btnFirstOptionsTitlePartnersPage" onClick={handleCloseThird}><FaArrowLeftLong className='navIconPartnersPage'/></button>
                                                        <div className='txtFirstOptionsTitlePartnersPage'>Localização</div>
                                                    </div>
                                                    <button className='btnFirstOptionsTitlePartnersPage' onClick={handleMainClose}><IoMdClose className="navIconPartnersPage"/></button>
                                                </div>
                                                <div className='optionsDeviderLinePartnersPage'></div> 
                                                <div className='txtFirstOptionsTitleViewPartnersPage'>
                                                    <div style={{ marginBottom: '24px'}}>
                                                        <div className='txtFirstOptionsTitlePartnersPage'>Concelho</div>
                                                    </div>
                                                    {selectedItem?.conselhos.map((item, index)=>(
                                                        <Form key={index}>
                                                            <div key={item.id} style={{ marginBottom: '32px' }} className='firstOptionsFormChekedViewPartnersPage'>
                                                                <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                                                    <Form.Check 
                                                                        type="checkbox" 
                                                                        label={''}
                                                                        checked={props.isCheckedConselhos(item)}
                                                                        onChange={(event) => props.handleCheckboxChange(event, item)}
                                                                    />
                                                                    {/* <div className='txtFormPartnersPage'>{`${item.name} (${item.code})`}</div> */}
                                                                    <div className='txtFormPartnersPage'>{`${item.name}`}</div>
                                                                </div>
                                                            </div>
                                                        </Form>
                                                    ))}
                                                    <div className='optionsDeviderLinePartnersPage'></div>
                                                    <div className='fotterMobalBtnViewPartnersPage' style={{ paddingTop: '32px', marginBottom: '64px'}}>
                                                        <CustomButton 
                                                            text={'Limpar tudo'} 
                                                            textColor={'#00214D'}
                                                            onPress={props.handleClearFilter} 
                                                            enabled={props.handleEnabledBtnFilter()}
                                                            color={'#fff'}
                                                            borderColor={'#00214D'}
                                                            isSmall
                                                        />
                                                        <CustomButton 
                                                            text={'Aplicar filtros'} 
                                                            color={'#15D4B6'}
                                                            textColor={'#00214D'}
                                                            onPress={handleMainClose}
                                                            enabled={props.handleEnabledBtnFilter()}
                                                            isSmall
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                    </Modal>  
                                </div>
                            </div>
                    </Modal>
                </div>                        
                <div className='optionsDeviderLinePartnersPage'></div>
                <div className='txtFirstOptionsTitleViewPartnersPage'>
                    <div style={{ marginBottom: '24px'}}>
                        <div className='txtFirstOptionsTitlePartnersPage'>Por categoria</div>
                    </div>
                    <Form>
                        <div className='firstOptionsFormChekedViewPartnersPage'>
                            <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                <Form.Check 
                                    type="checkbox" 
                                    label={''}
                                    checked={isAccommodationTravel}
                                    onChange={props.handleCheckboxChangeOne}
                                    disabled={countAccommodationTravel <= '0'}
                                />
                                <div className='txtFormPartnersPage' onClick={ countAccommodationTravel > 0 ? props.handleCheckboxChangeOne : null } style={{cursor: countAccommodationTravel > 0 ? 'pointer' : 'default'}}>{`Alojamento e Viagens (${countAccommodationTravel})`}</div>
                            </div>
                            <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                <Form.Check 
                                    type="checkbox" 
                                    label={''}
                                    checked={isSustainability}
                                    onChange={props.handleCheckboxChangeTwelve}
                                    disabled={countSustainability <= '0'}
                                />
                                <div className='txtFormPartnersPage' onClick={ countSustainability > 0 ? props.handleCheckboxChangeTwelve : null } style={{cursor: countSustainability > 0 ? 'pointer' : 'default'}}>{`Sustentabilidade (${countSustainability})`}</div>
                            </div>
                            <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                <Form.Check 
                                    type="checkbox" 
                                    label={''}
                                    checked={isSport}
                                    onChange={props.handleCheckboxChangeTwo}
                                    disabled={countSport <= '0'}
                                />
                                <div className='txtFormPartnersPage' onClick={ countSport > 0 ? props.handleCheckboxChangeTwo : null} style={{cursor: countSport > 0 ? 'pointer' : 'default'}}>{`Desporto e Nutrição (${countSport})`}</div>
                            </div>
                            <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                <Form.Check 
                                    type="checkbox" 
                                    label={''}
                                    checked={isBeautyStore}
                                    onChange={props.handleCheckboxChangeThree}
                                    disabled={countBeautyStore <= '0'}
                                />
                                <div className='txtFormPartnersPage' onClick={ countBeautyStore > 0 ? props.handleCheckboxChangeThree : null} style={{cursor: countBeautyStore > 0 ? 'pointer' : 'default'}}>{`Saúde e Beleza (${countBeautyStore})`}</div>
                            </div>
                            <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                <Form.Check 
                                    type="checkbox" 
                                    label={''}
                                    checked={isChildrenEducation}
                                    onChange={props.handleCheckboxChangeFour}
                                    disabled={countChildrenEducation <= '0'}
                                />
                                <div className='txtFormPartnersPage' onClick={ countChildrenEducation > 0 ? props.handleCheckboxChangeFour : null } style={{cursor: countChildrenEducation > 0 ? 'pointer' : 'default'}}>{`Crianças e Educação (${countChildrenEducation})`}</div>
                            </div>
                            <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                <Form.Check 
                                    type="checkbox" 
                                    label={''}
                                    checked={isCultureLeisure}
                                    onChange={props.handleCheckboxChangeFive}
                                    disabled={countCultureLeisure <= '0'}
                                />
                                <div className='txtFormPartnersPage' onClick={ countCultureLeisure > 0 ? props.handleCheckboxChangeFive : null} style={{cursor: countCultureLeisure > 0 ? 'pointer' : 'default'}}>{`Cultura e Lazer (${countCultureLeisure})`}</div>
                            </div>
                            <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                <Form.Check 
                                    type="checkbox" 
                                    label={''}
                                    checked={isTech}
                                    onChange={props.handleCheckboxChangeSix}
                                    disabled={countTech <= '0'}
                                />
                                <div className='txtFormPartnersPage' onClick={ countTech > 0 ? props.handleCheckboxChangeSix : null } style={{cursor: countTech > 0 ? 'pointer' : 'default'}}>{`Tecnologia (${countTech})`}</div>
                            </div>
                            <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                <Form.Check 
                                    type="checkbox" 
                                    label={''}
                                    checked={isModaHome}
                                    onChange={props.handleCheckboxChangeSeven}
                                    disabled={countModaHome <= '0'}
                                />
                                <div className='txtFormPartnersPage' onClick={ countModaHome > 0 ? props.handleCheckboxChangeSeven : null } style={{cursor: countModaHome > 0 ? 'pointer' : 'default' }}>{`Moda e Casa (${countModaHome})`}</div>
                            </div>
                            <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                <Form.Check 
                                    type="checkbox" 
                                    label={''}
                                    checked={isAnimals}
                                    onChange={props.handleCheckboxChangeEight}
                                    disabled={countAnimals <= '0'}
                                />
                                <div className='txtFormPartnersPage' onClick={ countAnimals > 0 ? props.handleCheckboxChangeEight : null } style={{cursor: countAnimals > 0 ? 'pointer' : 'default' }}>{`Animais (${countAnimals})`}</div>
                            </div>
                            <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                <Form.Check 
                                    type="checkbox" 
                                    label={''}
                                    checked={isCarsTransp}
                                    onChange={props.handleCheckboxChangeNine}
                                    disabled={countCarsTransp <= '0'}
                                />
                                <div className='txtFormPartnersPage' onClick={ countCarsTransp > 0 ? props.handleCheckboxChangeNine : null} style={{cursor: countCarsTransp > 0 ? 'pointer' : 'default' }}>{`Mobilidade (${countCarsTransp})`}</div>
                            </div>
                            <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                <Form.Check 
                                    type="checkbox" 
                                    label={''}
                                    checked={isRestaurantStore}
                                    onChange={props.handleCheckboxChangeEleven}
                                    disabled={countRestaurantStore <= '0'}
                                />
                                <div className='txtFormPartnersPage' onClick={ countRestaurantStore > 0 ? props.handleCheckboxChangeEleven : null } style={{cursor: countRestaurantStore > 0 ? 'pointer' : 'default' }}>{`Restauração e Supermercados (${countRestaurantStore})`}</div>
                            </div>
                            <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                <Form.Check 
                                    type="checkbox" 
                                    label={''}
                                    checked={isOther}
                                    onChange={props.handleCheckboxChangeTen}
                                    disabled={countOther <= '0'}
                                />
                                <div className='txtFormPartnersPage' onClick={ countOther > 0 ? props.handleCheckboxChangeTen : null } style={{cursor: countOther >  0 ? 'pointer' : 'default' }}>{`Outros (${countOther})`}</div>
                            </div>
                        </div>
                    </Form>
                </div>
                <div className='optionsDeviderLinePartnersPage'></div>
                <div className='txtFirstOptionsTitleViewPartnersPage'>
                    <div style={{ marginBottom: '24px'}}>
                        <div className='txtFirstOptionsTitlePartnersPage'>Opção de compra</div>
                    </div>
                    <Form>
                        <div className='firstOptionsFormChekedViewPartnersPage'>
                            <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                <Form.Check 
                                    type="checkbox" 
                                    label={''}
                                    checked={isStorePhysical}
                                    onChange={props.handleCheckboxChangeStorePhysical}
                                    disabled={countStorePhysical <= '0'}
                                />
                                <div className='txtFormPartnersPage' onClick={ countStorePhysical > 0 ? props.handleCheckboxChangeStorePhysical : null} style={{cursor: countStorePhysical > 0 ? 'pointer' : 'default' }}>{`Loja física (${countStorePhysical})`}</div>
                            </div>
                            <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                <Form.Check 
                                    type="checkbox" 
                                    label={''}
                                    checked={isStoreOnline}
                                    onChange={props.handleCheckboxChangeStoreOnline}
                                    disabled={countStoreOnline <= '0'}
                                />
                                <div className='txtFormPartnersPage' onClick={ countStoreOnline > 0 ? props.handleCheckboxChangeStoreOnline : null } style={{cursor: countStoreOnline > 0 ? 'pointer' : 'default' }}>{`Loja online (${countStoreOnline})`}</div>
                            </div>
                        </div>
                    </Form>
                </div>
                <div className='optionsDeviderLinePartnersPage'></div>
                <div className='txtFirstOptionsTitleViewPartnersPage'>
                    <div style={{ marginBottom: '24px'}}>
                        <div className='txtFirstOptionsTitlePartnersPage'>Novas parcerias</div>
                    </div>
                    <Form>
                        <div className='firstOptionsFormChekedViewPartnersPage'>
                            <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                <Form.Check 
                                    type="checkbox" 
                                    label={''}
                                    checked={isNew}
                                    onChange={props.handleCheckboxChangeNew}
                                    disabled={countNew <= '0'}
                                />
                                <div className='txtFormPartnersPage' onClick={ countNew > 0 ? props.handleCheckboxChangeNew : null } style={{cursor: countNew > 0 ? 'pointer' : 'default' }}>{`Mostrar apenas novidades (${countNew})`}</div>
                            </div>
                        </div>
                    </Form>
                </div>
                <div className='optionsDeviderLinePartnersPage'></div>
                <div className='fotterMobalBtnViewPartnersPage'>
                    <CustomButton 
                        text={'Limpar tudo'} 
                        textColor={'#00214D'}
                        onPress={props.handleClearFilter}
                        enabled={props.handleEnabledBtnFilter()}
                        color={'#fff'}
                        borderColor={'#00214D'}
                        isSmall
                    />
                    <CustomButton 
                        text={'Aplicar filtros'} 
                        color={'#15D4B6'}
                        textColor={'#00214D'}
                        onPress={handleMainClose}
                        enabled={props.handleEnabledBtnFilter()}
                        isSmall
                    />
                </div>
            </div>            
        </Modal>
    );
};

export default CustomFilterModal;